import React from 'react'
import { OperateRecord } from './staff-operate-record-table'
// import { Row } from '@/components/layout/layout'

export const getOperateDetail = (recordDetial: OperateRecord) => {
    function transform(type: any) {
        switch (type) {
            case 0:
                return '一'
            case 1:
                return '二'
            case 2:
                return '三'
        }
    }

    function getSencesValue(sences: any[]) {
        if (sences.length === 2) {
            return '商城/收银台'
        }
        if (sences.includes(0)) {
            return '收银台'
        }
        if (sences.includes(1)) {
            return '商城'
        }
    }

    if (recordDetial.source === 11) {
        return <span>{recordDetial.detail.batch_detail}</span>
    }

    switch (recordDetial.operate_type) {
        case 0:
            return (
                <span>
                    订单{recordDetial.detail.order_refund_info.order_no}
                    ，退款{recordDetial.detail && recordDetial.detail.order_refund_info.refund_money}元
                </span>
            )
        case 23:
            const transformScene = (scene: number) => (scene ? '微商城' : '收银台')

            return (
                <span>
                    创建了
                    {recordDetial.detail.timed_discount_info.activity.scenes
                        .map((item: number) => transformScene(item))
                        .join('、')}
                    的限时折扣活动
                </span>
            )

        case 25:
            return (
                <div className="fx-h-between expaned">
                    <span>停用了商城的限时折扣</span>
                    {/* <Row data-align-items-center>
                        <div
                            style={{
                                color: '#3C90FF',
                                fontSize: '14px',
                                marginRight: '4px',
                            }}
                        >
                            活动详情
                        </div>
                    </Row> */}
                </div>
            )

        case 17:
            return (
                <span>{`${recordDetial.detail.order_export_info.operate_detail}共${recordDetial.detail.order_export_info.exported_order_count}条订单记录`}</span>
            )

        case 1:
            // 商品种类 合计
            const count = recordDetial.detail.operate_goods_info.length
            const totalMoney = recordDetial.detail.operate_goods_info.reduce((pre: any, next: any) => {
                return pre + next.subtotal
            }, 0)
            const goodsList: any[] = []
            recordDetial.detail.operate_goods_info.forEach((item: any) => {
                goodsList.push(item.goods_name)
            })

            return (
                <span>
                    挂单中包含（{goodsList.join('、')}）{count}种商品，共计{totalMoney}元
                </span>
            )

        case 2:
            return (
                <div style={{ flexDirection: 'column' }}>
                    {recordDetial.detail.operate_goods_info.map((item: any, index: any) => {
                        return (
                            <span key={index}>
                                <span>
                                    {item.goods_name},{item.sale_price.sale_price}元/{item.sale_price.sale_unit.name}，
                                    {item.amount}
                                    {item.sale_price.sale_unit.name}，小计{item.subtotal}元
                                </span>
                            </span>
                        )
                    })}
                </div>
            )

        case 3:
            return (
                <div style={{ flexDirection: 'column' }}>
                    {recordDetial.detail.price_change_info.map((item: any, index: any) => {
                        return (
                            <span key={index}>
                                {item.goods_name}售价修改为{item.sale_price}元/{item.sale_unit.name}；
                            </span>
                        )
                    })}
                </div>
            )

        case 4:
            return (
                <div style={{ flexDirection: 'column' }}>
                    {recordDetial.detail.price_change_info.map((item: any, index: any) => {
                        return (
                            <span key={index}>
                                {item.goods_name}售价修改为{item.sale_price}元/{item.sale_unit.name}；
                            </span>
                        )
                    })}
                </div>
            )

        case 5:
            return (
                <p style={{ flexDirection: 'column' }}>
                    {recordDetial.detail.price_change_info[0].goods_name}的售价改为：
                    {recordDetial.detail.price_change_info.map((item: any, index: any) => {
                        return (
                            <span key={index}>
                                {transform(index)}级，购买量{'>'}={item.threshold}，{item.sale_price}元/
                                {item.sale_unit.name}；
                            </span>
                        )
                    })}
                </p>
            )

        case 6:
            return (
                <span>
                    订单{recordDetial.detail && recordDetial.detail.order_discount_info.order.order_no}
                    商品总价为{recordDetial.detail && recordDetial.detail.order_discount_info.order.subtotal}元， 折扣(
                    {recordDetial.detail && recordDetial.detail.order_discount_info.discount_rate * 10})折 优惠
                    {recordDetial.detail && recordDetial.detail.order_discount_info.discount_amount}元
                </span>
            )

        case 7:
            return (
                <span>
                    订单
                    {recordDetial.detail && recordDetial.detail.order_discount_info.order.order_no}， 商品总价为
                    {recordDetial.detail && recordDetial.detail.order_discount_info.order.subtotal}元， 减免优惠
                    {recordDetial.detail && recordDetial.detail.order_discount_info.discount_amount}元
                </span>
            )

        case 8:
            return (
                <span>
                    订单{recordDetial.detail && recordDetial.detail.order_discount_info.order.order_no}， 商品总价为
                    {recordDetial.detail && recordDetial.detail.order_discount_info.order.subtotal}元， 抹零优惠
                    {recordDetial.detail && recordDetial.detail.order_discount_info.discount_amount}元
                </span>
            )

        case 9:
            const unit = recordDetial.detail && recordDetial.detail.goods_amount_change_info.sale_price.sale_unit.name

            return (
                <span>
                    {recordDetial.detail && recordDetial.detail.goods_amount_change_info.goods_name}，
                    {recordDetial.detail && recordDetial.detail.goods_amount_change_info.origin_amount}
                    {unit}修改为
                    {recordDetial.detail && recordDetial.detail.goods_amount_change_info.modified_amount}
                    {unit}
                </span>
            )

        case 12:
            const recordDetialIno = recordDetial.detail.edit_member_name_info

            return (
                <span>
                    {recordDetialIno.origin_name} 修改为 {recordDetialIno.modified_name}
                </span>
            )

        case 13:
            const recordDetialIn = recordDetial.detail.edit_member_phone_info

            return (
                <span>
                    会员【{recordDetialIn.member.name}】，{recordDetialIn.origin_phone} 修改为{' '}
                    {recordDetialIn.modified_phone}
                </span>
            )

        case 14:
            const recordDetialIno14 = recordDetial.detail.edit_member_birthday_info

            return (
                <span>
                    会员【{recordDetialIno14.member.name}】，{recordDetialIno14.origin_birthday} 修改为{' '}
                    {recordDetialIno14.modified_birthday}
                </span>
            )

        case 15:
            const recordDetialIno15 = recordDetial.detail.delete_member_info

            return (
                <span>
                    会员【{recordDetialIno15.member.name}】，{recordDetialIno15.member.phone}
                </span>
            )

        case 22:
            const recordDetialIno22 = recordDetial.detail.edit_member_card_code_info || {}
            const user = (recordDetialIno.member && recordDetialIno.member.user) || {}

            return (
                <div className="line-height-20">
                    <span className="padding-right-6">会员</span>
                    <img
                        className="width-18 height-18 border-radius-9 margin-right-4"
                        style={{ verticalAlign: 'top' }}
                        src={user.avatar}
                        alt=""
                    />
                    <span className="padding-right-6">
                        {user.nickname}
                        {user.realname && '(' + user.realname + ')'}
                    </span>
                    会员卡号由<span className="padding-h-4">{recordDetialIno22.origin_card_code}</span>
                    修改为<span className="padding-h-4">{recordDetialIno22.modified_card_code}</span>
                </div>
            )

        case 26:
            const recordDetialIno26 = recordDetial.detail.minus_send_activity || {}

            return <div className="line-height-20">为{getSencesValue(recordDetialIno26.scenes)}创建了满减满送</div>

        case 27:
            const recordDetialIno27 = recordDetial.detail.minus_send_activity || {}

            return <div className="line-height-20">编辑了{getSencesValue(recordDetialIno27.scenes)}的满减满送</div>

        case 28:
            const recordDetialIno28 = recordDetial.detail.minus_send_activity || {}

            return (
                <div className="line-height-20">
                    <div className="line-height-20">停用了{getSencesValue(recordDetialIno28.scenes)}满减满送</div>
                </div>
            )

        case 29:
            const recordDetialIno29 = recordDetial.detail.minus_send_activity || {}

            return (
                <div className="line-height-20">
                    <div className="line-height-20">启用了{getSencesValue(recordDetialIno29.scenes)}满减满送</div>
                </div>
            )

        case 30:
            const recordDetialIno30 = recordDetial.detail.confirm_profit_info || {}

            return (
                <div className="line-height-20 row align-items-flex-start">
                    <div>确认了{recordDetialIno30.date}的日利润报表</div>
                    <div className="line-height-20 fx-v-center flex-shrink-0">
                        <span className="color-blue">报表详情</span>
                    </div>
                </div>
            )

        case 31:
            const recordDetialIno31 = recordDetial.detail.correct_cost_price_info || {}

            return (
                <div className="line-height-20">
                    修正了商品<span className="padding-h-4">{recordDetialIno31.goods_name}</span>的成本价
                </div>
            )

        case 32:
            const recordDetialIno32 = recordDetial.detail.groupon_application || {}
            if (recordDetialIno32.status === 1) {
                return (
                    <div className="line-height-20">
                        同意了团长{recordDetialIno32.user.nickname}的申请，增加了
                        {recordDetialIno32.self_pickup_sites[0].name}自提点
                    </div>
                )
            } else {
                return <div className="line-height-20 row">拒绝了{recordDetialIno32.user.nickname}的申请</div>
            }

        case 33:
            return <div className="line-height-20">开启了社区团购模块</div>

        case 34:
            return <div className="line-height-20">关闭了社区团购模块</div>

        case 42:
            const rechargeBonusInfo = recordDetial.detail.recharge_bonus_info || {}

            return (
                <span>
                    充值单{rechargeBonusInfo.order_no}，充值{rechargeBonusInfo.recharge_amount}元，赠送金额由
                    {rechargeBonusInfo.rule_bonus_amount}元修改为{rechargeBonusInfo.actual_bonus_amount}元
                </span>
            )
    }
}

export const OperateMap: {
    [key: string]: string
} = {
    0: '收银台',
    1: '后台-订单',
    2: 'APP-订单',
    3: 'APP-会员',
    6: 'APP-限时折扣',
    7: 'APP-满减满送',
    8: 'APP-利润报表',
    9: 'APP-成本价',
    10: 'APP-社区团购',
    11: '批量操作',
}
